import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const authLogin = (username, password) =>
  api.post("/auth/login", { username, password }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);

export const getMeta = () => api.get("/meta").then((r) => r.data);
export const getFilterOptions = () => api.get("/filters/options").then((r) => r.data);
export const getOverview = (scenario, days = 7) =>
  api.get("/overview", { params: { scenario, days } }).then((r) => r.data);
export const getStream = (stream, scenario, days = 30) =>
  api.get(`/streams/${stream}`, { params: { scenario, days } }).then((r) => r.data);
export const getApplications = (params) =>
  api.get("/applications", { params }).then((r) => r.data);
export const getApplication = (id, scenario) =>
  api.get(`/applications/${id}`, { params: { scenario } }).then((r) => r.data);
export const getScoreExplanation = (id, scenario) =>
  api.get(`/applications/${id}/score-explanation`, { params: { scenario } }).then((r) => r.data);
export const getScoringConfig = () => api.get("/scoring/config").then((r) => r.data);
export const putScoringConfig = (value, changed_by = "admin") =>
  api.put("/scoring/config", { value, changed_by }).then((r) => r.data);
export const previewScoringConfig = (value, scenario, changed_by = "admin") =>
  api.post("/scoring/preview", { value, changed_by }, { params: { scenario } }).then((r) => r.data);
export const getAudit = () => api.get("/audit").then((r) => r.data);
export const getManifest = () => api.get("/ingest/manifest").then((r) => r.data);
export const getScenarioComparison = () =>
  api.get("/scenario-comparison").then((r) => r.data);
